import { DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST, GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_TAKA_NO, DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST_FAILURE } from '../types';

const initialState = {
  takaNos: [],
  loading: false,
  error: null,
};

const deliveryChallanReturnTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_TAKA_NO: {
      return {
        ...state,
        takaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case DELIVERY_CHALLAN_RETURN_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default deliveryChallanReturnTransactionReducer;
